import React from 'react';
import { Base64TextEncoder } from '../components/base64-text-encoder/Base64TextEncoder';
import '../components/base64-text-encoder/Base64TextEncoder.css';

export const Base64TextEncoderPage: React.FC = () => {
  return (
    <div className="page-container">
      <Base64TextEncoder />
    </div>
  );
};